import btnClickUrl from "@/components/with-quote-data-config";

const getLoginPageUrl = (brand: string): string => {
  let loginBtnClickUrl = "";
  btnClickUrl.forEach((loginUrl) => {
    if (loginUrl.brand === brand) {
      loginBtnClickUrl = loginUrl.logoUrl;
    }
  });
  return loginBtnClickUrl;
};

export default getLoginPageUrl;
